
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/visit-us",
      function () {
        return require("private-next-pages/locale/visit-us.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/visit-us"])
      });
    }
  